import React from 'react';

import { Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';
import { useTranslation } from 'react-i18next';

import StarEdgyFilledIcon from '../../../../assets/icons/StarEdgyFilledIcon';
import StarEdgyIcon from '../../../../assets/icons/StarEdgyIcon';
import { colorsPalette, MIDDLE_MARGIN } from '../../../../theme';

interface RatingProps {
  value?: number;
  hideValue?: boolean;
  wrapperClass?: string;
  name?: string;
}

const stars = new Array(5).fill(null);

const Rating = ({ value = 0, hideValue = false, wrapperClass, name }: RatingProps) => {
  const { t } = useTranslation();
  return (
    <Wrapper className={wrapperClass}>
      {stars.map((s, i) =>
        i + 1 <= value ? (
          <FilledStarIcon data-testid={name + 'FilledIcon'} key={i} />
        ) : (
          <StarIcon data-testid={name + 'OutlinedIcon'} key={i} />
        ),
      )}
      {!hideValue ? (
        !value ? (
          <Caption>{t('page.video.noReviews')}</Caption>
        ) : (
          <Caption data-testid="ratingValue" variant="h3">
            {value?.toFixed(1)}
          </Caption>
        )
      ) : null}
    </Wrapper>
  );
};

export default Rating;

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: MIDDLE_MARGIN,
});
const Caption = styled(Typography)({
  marginLeft: 6,
  marginBottom: 0,
  fontSize: 20,
  color: colorsPalette.blue,
});
const StarIcon = styled(StarEdgyIcon)(({ theme }: { theme: Theme }) => ({
  width: 20,
  height: 20,
  marginRight: 6,
  color: colorsPalette.blue,
  [theme.breakpoints.up('md')]: {
    width: 24,
    height: 24,
  },
}));
const FilledStarIcon = styled(StarEdgyFilledIcon)(({ theme }: { theme: Theme }) => ({
  width: 20,
  height: 20,
  marginRight: 6,
  color: colorsPalette.blue,
  [theme.breakpoints.up('md')]: {
    width: 24,
    height: 24,
  },
}));
